'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

exports.default = init;

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _helpers = require('./_helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var activeClass = 'sec-Popup-active';
  var popupModal = el;
  var cookieClose = context.getElement('.' + context.className + '_Close');

  var cookieName = 'BAO-popup';
  var listeners = (0, _create2.default)(_helpers.Listeners);

  var popupDelay = parseInt(popupModal.dataset.delay) * 1000;

  if (_jsCookie2.default.get(cookieName) === 'true') {
    return;
  }

  setTimeout(function () {
    popupModal.classList.add(activeClass);

    _jsCookie2.default.set(cookieName, 'true', { expires: 7 });
  }, popupDelay);

  listeners.add(cookieClose, 'click', removeNotificationBar);

  function removeNotificationBar() {
    popupModal.classList.remove(activeClass);
  }
}